export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="section-wrap site-footer__inner">
        <a className="brand brand--footer" href="#home">
          <span className="brand__mark">CH</span>
          <span className="brand__text">
            <strong>Colin Harrison</strong>
            <small>Software contractor</small>
          </span>
        </a>
        <p>Independent software engineering · {new Date().getFullYear()}</p>
        <a className="site-footer__top" href="#home">Back to top ↑</a>
      </div>
    </footer>
  );
}
